import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  // required - Thông tin đơn hàng
  don_hang: {
    don_hang_id: undefined, // required, ref: don_hang - Mã đơn hàng
    ma: undefined, // required - Mã đơn hàng
    tien: undefined, // required, min: 0 - Tổng tiền đơn hàng
  },
  // required - Thông tin dòng họ
  dong_ho: {
    dong_ho_id: undefined, // required, ref: dong_ho - Mã dòng họ
    ten: undefined, // required
  },
  nguoi_thanh_toan_id: undefined, // required, ref: nguoi_dung
  // required - Thông tin phương thức thanh toán
  phuong_thuc_thanh_toan: {
    pttt_id: undefined, // required, ref: phuong_thuc_thanh_toan - Mã phương thức thanh toán
    ten: undefined, // required - Tên phương thức thanh toán
  },
  // required - Phí thanh toán
  phi: {
    khach: undefined, // required, min: 0 - Phí thanh toán (khách chịu)
    he_thong: undefined, // required, min: 0 - Phí thanh toán (hệ thống chịu)
  },
  tien_thanh_toan: undefined, // required, min: 0 - Tiền cần thanh toán. =don_hang.tien + phi.khach
  trang_thai: undefined, // required, enum(cho_thanh_toan, da_thanh_toan, huy) - Trạng thái thanh toán
  // optional - Các log thời gian
  thoi_diem: {
    tao: undefined, // required - Thời điểm tạo
    thanh_toan: undefined, // optional - Thời điểm thanh toán
    huy: undefined, // optional - Thời điểm hủy
  },
};

model.trangThai = [
  {
    value: "cho_thanh_toan",
    label: "Chờ thanh toán",
  },
  {
    value: "da_thanh_toan",
    label: "Đã thanh toán",
  },
  {
    value: "huy",
    label: "Hủy",
  },
];

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem.tao",
  defaultSort: ["thoi_diem.tao", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      "don_hang.ma": "",
      "dong_ho.ten": "",
      trang_thai: "",
    },
    valid: {
      "thoi_diem.tao": []
    },
    operator: {
      "don_hang.ma": ":regex_i:",
      "dong_ho.ten": ":regex_i:",
      trang_thai: ":regex_i:",
    },
  },
};

export default model;
